import { apiClient } from './client'

/**
 * Moja Biblioteka API client.
 *
 * All functions call the Flask backend under /api/v1/me/*.
 * Session cookies are sent automatically by apiClient.
 */

/**
 * Fetch the current user's profile.
 */
export async function getProfile() {
  return apiClient('/me/profile')
}

/**
 * Update the current user's profile.
 */
export async function updateProfile(profile) {
  return apiClient('/me/profile', {
    method: 'PUT',
    body: JSON.stringify(profile),
  })
}

/**
 * Delete the current user's account.
 */
export async function deleteAccount() {
  return apiClient('/me/profile', {
    method: 'DELETE',
  })
}

/**
 * Fetch the user's active/pending/finished tier subscriptions.
 */
export async function getUserSubscriptions() {
  return apiClient('/me/subscriptions')
}

/**
 * Update preferences for one user subscription.
 */
export async function updateSubscriptionPreferences(id, preferences) {
  return apiClient(`/me/subscriptions/${id}/preferences`, {
    method: 'PATCH',
    body: JSON.stringify({ preferences }),
  })
}

/**
 * Resume payment for an unpaid subscription and return the Stripe Checkout URL.
 */
export async function completeSubscriptionPayment(id) {
  return apiClient(`/me/subscriptions/${id}/pay`, {
    method: 'POST',
  })
}

/**
 * Cancel an active/pending subscription (sets cancel_at_period_end on Stripe).
 */
export async function cancelSubscription(id) {
  return apiClient(`/me/subscriptions/${id}/cancel`, {
    method: 'POST',
  })
}

/**
 * Fetch all books/items sent to the user.
 */
export async function getItems() {
  return apiClient('/me/items')
}

/**
 * Update the review and rating for one item.
 */
export async function updateItemReview(itemId, { rating, review }) {
  return apiClient(`/me/items/${itemId}/review`, {
    method: 'PATCH',
    body: JSON.stringify({ rating, review }),
  })
}

/**
 * Fetch all bookseller message threads for the current user.
 */
export async function getMessages() {
  return apiClient('/me/messages')
}

/**
 * Create a new bookseller message thread.
 */
export async function sendMessage({ subject, body }) {
  return apiClient('/me/messages', {
    method: 'POST',
    body: JSON.stringify({ subject, body }),
  })
}

/**
 * Reply to an existing bookseller message thread.
 *
 * Requires backend endpoint: POST /api/v1/me/messages/:id/reply
 */
export async function replyToThread(threadId, body) {
  return apiClient(`/me/messages/${threadId}/reply`, {
    method: 'POST',
    body: JSON.stringify({ body }),
  })
}

/**
 * Mark a bookseller message thread as read.
 *
 * Requires backend endpoint: PATCH /api/v1/me/messages/:id/read
 */
export async function markThreadRead(threadId) {
  return apiClient(`/me/messages/${threadId}/read`, {
    method: 'PATCH',
  })
}
